import React from "react";
import { Transition } from "react-transition-group";

const defaultStyles = {
  transition: "height 250ms ease-in-out",
  overflow: "hidden"
};

const SlideOut = ({ inProp, height, children }) => (
  <Transition in={inProp} timeout={250}>
    {state => {
      return (
        <div
          style={{
            ...defaultStyles,
            ...{ exiting: { height }, exited: { height: 0 } }[state]
          }}
          aria-hidden={state === "exited"}
        >
          {children}
        </div>
      );
    }}
  </Transition>
);

export default SlideOut;
